import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { ChevronDown } from "lucide-react";
import { GENRES } from "../lib/genres";

// "Genres" dropdown for the top nav — a single, skin-agnostic browse entry point.
export default function GenreMenu({ linkClassName = "" }) {
  const [open, setOpen] = useState(false);
  const navigate = useNavigate();
  const go = (slug) => { setOpen(false); navigate(`/genre/${slug}`); };

  return (
    <div className="relative">
      <button
        onClick={() => setOpen((o) => !o)}
        data-testid="nav-genres-button"
        className={linkClassName || "inline-flex items-center gap-1 text-sm font-medium text-[var(--text-secondary)] hover:text-[var(--text-primary)]"}
      >
        Genres <ChevronDown size={14} className={`transition-transform ${open ? "rotate-180" : ""}`} />
      </button>
      {open && (
        <>
          <div className="fixed inset-0 z-40" onClick={() => setOpen(false)} />
          <div
            className="absolute left-0 z-50 mt-2 grid w-[min(92vw,420px)] grid-cols-2 gap-1 rounded-[var(--card-radius)] border border-[var(--border-subtle)] bg-[var(--bg-surface)] p-2 shadow-2xl sm:grid-cols-3"
            data-testid="nav-genres-menu"
          >
            {GENRES.map((g) => (
              <button
                key={g.slug}
                onClick={() => go(g.slug)}
                data-testid={`nav-genre-${g.slug}`}
                className="rounded-[var(--card-radius)] px-3 py-2 text-left text-sm text-[var(--text-primary)] transition-colors hover:bg-[var(--accent)]/10 hover:text-[var(--accent-hover)]"
              >
                {g.name}
              </button>
            ))}
          </div>
        </>
      )}
    </div>
  );
}
